import AdComponent from "components/AdComponent";
import React, { Component } from "react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import ReactSwipe from "react-swipe";
import { setClickLogapi } from "helpers";
import { adBannerInfo } from "actions/adBanner.action";

class Banner extends Component {
    constructor(props) {
        super(props);
        this.props.adBannerInfo();
        this.state = {
            selectedIndex: 0,
        };
    }
    
    handleTransitionEnd = (index) => {
        if (this.state.selectedIndex === index) {
            return false;
        }
        this.setState({
            selectedIndex: index,
        });
    };

    chunks = (array, size) => {
        let results = [];
        for (let i = 0; i < array.length; i += 2) {
            results.push(array.slice(i, i + size));
        }
        return results;
    };

    renderBanner = (banner, index = 0) => {
        return (
            <a key={index} href={banner.link || "javascript:;"} target={banner.link ? "_blank" : ""} rel="noopener noreferrer" 
                onClick={() => setClickLogapi('station_click', { button_group: 'banner', button_type: 'bottom_banner'})}>
                <img src={banner.url} alt={banner.alt} />
            </a>
        );
    };
    render() {
        const { banners = [], is_adsence = false, adBannerOnOff = {} } = this.props;

        const { bannerOnOff = false } = adBannerOnOff.bannerControlArr;
        const width = window.innerWidth > 0 ? window.innerWidth : window.screen.width;
        if (isMobile) {
            if (banners && banners.length > 0) {
                const wildeBanners = this.chunks(banners, 2);
                return (
                    <div className="sct-bnr">
                        <div className="wapper">
                            <ReactSwipe
                                swipeOptions={{
                                    continuous: true,
                                    stopPropagation: true,
                                    startSlide: this.state.selectedIndex,
                                    transitionEnd: this.handleTransitionEnd,
                                }}
                                className="carousel"
                                ref={(ref) => (this.reactSwipeEl = ref)}
                            >
                                {width >= 768
                                    ? [
                                          wildeBanners.map((banner, index) => (
                                              <div>
                                                  {this.renderBanner(banner[0], index)}
                                                  {banner[1] && this.renderBanner(banner[1], index)}
                                              </div>
                                          )),
                                          wildeBanners.length === 2 &&
                                              wildeBanners.map((banner, index) => (
                                                  <div>
                                                      {this.renderBanner(banner[0], index)}
                                                      {banner[1] && this.renderBanner(banner[1], index)}
                                                  </div>
                                              )),
                                      ]
                                    : [
                                          banners.map((banner, index) => <div>{this.renderBanner(banner, index)}</div>),
                                          banners.length === 2 &&
                                              banners.map((banner, index) => <div>{this.renderBanner(banner, index)}</div>),
                                      ]}
                            </ReactSwipe>
                            {banners.length > 1 && <div className="slide_paging">
                                {(this.state.selectedIndex % banners.length) + 1}<em>/</em>{banners.length}
                            </div>}
                        </div>
                    </div>
                );
            } else {
                return null;
            }
        } else {
            return (
                <div className="sct-bnr">
                    {banners.map((banner, index) => this.renderBanner(banner, index))}
                    {is_adsence && (
                        <React.Fragment>
                            <AdComponent code="x48" />
                            {banners.length % 2 === 0 && <AdComponent code="x49"  />}
                        </React.Fragment>
                    )}
                </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        adBannerOnOff: state.adBannerReducer,
    };
};
// props 값으로 넣어 줄 상태를 정의해줍니다.
const mapDispatchToProps = (dispatch) => {
    return {
        adBannerInfo: () => {
            dispatch(adBannerInfo());
        }
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Banner);
